<template>
    <div class="filter-wrapper" :style="customStyle">
            <div style="display: flex; flex-direction: column;">
                <div cols="3" style="display: flex; align-items: center; justify-content: end;">
                    <span class="toggle-text">
                        With Closed
                    </span>
                    <div @click="projectStatusChangeHandler" :class="[!defaultStatus ? 'toggle-switch' : 'toggle-switch on']"></div>
                </div>
                    
                <div style="display: flex; align-items: center;">
                    <label for="project-option" class="project-option-label">Project</label>
                    <select class="form-control project-select-option" @change="projectIdChangeHandler" :value="selectedProjectId"
                        name="project-select-option">
                        <option v-if="project.projectId != ''" v-for="project in getProjectOptions()" :value="project.projectId" :key="project.projectId">
                        {{ project.text }}</option>
                    </select>
                </div>
            </div>
    </div>

    <!-- <b-row class="project-filter" :style="customStyle">
        <b-col cols="1" class="nowrap">
            <label for="project-option" class="project-option-label">Project</label>
        </b-col>

        <b-col cols="4">
            <select class="form-control project-select-option" @change="FilterChangeHandler" :value="selectedProjectId"
                name="project-select-option">
                <option value=""></option>
                <option v-if="project.projectId != ''" v-for="project in filteredProjectOptions" :value="project.projectId">
                {{ project.name }}</option>
            </select>
        </b-col>
        <b-col cols="3">
            <select class="form-control project-select-option" v-model="projectOptionFilterCondition">
                <option value="ALL">All</option>
                <option value="OPEN">Open</option>
                <option value="CLOSED">Closed</option>
            </select>
        </b-col>
    </b-row> -->
</template>
<script>
export default {
    name : "ProjectFilter",
    props: {
        selectedProjectId: {default: ""},
        defaultStatus: {default: false},
        customStyle: {type:Object, default: () => {}}
    },
    created() {
        this.projectOptionFilterCondition = this.defaultStatus;
    },
    
    data() {
        return {
            projectId : '',
            projectOptionFilterCondition : "",
        }
    },
    computed: {
        withClosedProject() {
            return this.projectOptionFilterCondition;
        }
    },
    methods: {
        getProjectOptions() {
            let optionsObj = this.$store.getters['chatter/options']['projectOptions'];
            const allOption = { value: "", text: "Select a Project"};
            //toggle 여부에 따라 보이는 project 다르게
            if (this.defaultStatus == false) {
                return [allOption, ...optionsObj.filter(obj => obj.status == "OPEN")]
            }

            return [allOption, ...optionsObj];
        },

        projectIdChangeHandler(e) {
            console.log(e);
            const projectId = e.target.value;
            this.$emit('changeProject', projectId);
        },
        projectStatusChangeHandler() {
            this.$emit('changeWithClosed', !this.defaultStatus);
            // this.projectOptionFilterCondition = !this.projectOptionFilterCondition;
        }
    }
}

</script>
<style scoped>

@import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');
* {
  font-family: "NanumGothic";
}

.filter-wrapper {
    display: flex;
    flex-direction: column;
}


.project-option-label {
  font-size: 20px;
  margin-right: 1em;
}

.project-select-option {
  min-width: 13em;
  width: 100%;
  padding: 0.433rem 2.266rem 0.433rem 1.066rem;
  margin-bottom: 0;
  height: 40px;
  border-radius: 10px;
  color: #2E2E38;
  font-weight: 400;
  line-height: 150%;
  font-size: 18px;
  font-family: 'NanumGothic';
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 12px) 12px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  appearance: none;
}

.project-filter > * {
    display: flex;
    align-items: center;
    text-align: center
}

.toggle-align{
  display: flex;
  justify-content: end;
  margin: unset;
  gap: 10px;
  /* margin-left: 22%; */
}

.toggle-text{
  font-weight: 400;
  line-height: 150%;
  font-size: 18px;
  font-family: 'NanumGothic';
  /* margin-right: 0.3em; */
}

.toggle-switch {
  position: relative;
  margin-left: 0.3em;
  width: 36px;
  height: 20px;
  border-radius: 20px;
  background: #DDDDE3;
  transition: 0.3s;
}

.toggle-switch.on {
  background: #142459;
}

.toggle-switch::after {
  content: '';
  display: block;
  position: absolute;
  top: 2px;
  left: 2px;
  border-radius: 50%;
  background-color: #fff;
  width: 16px;
  height: 16px;
  transition: 0.3s;
}

.toggle-switch.on::after {
  transform: translateX(100%);
}

</style>